import React, { useState } from 'react';
import {
  BackButton,
  ThinTextField,
  ThinDropdown,
  AddButton,
} from '../../common/GeneralComponent';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';
import Loader from '../../../components/partials/Loader';
import { fetchData } from '../../../utils/functions';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2MB

const AddFeature = () => {
  const [loader, setLoader] = useState(false);
  const [imagePreview, setImagePreview] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues: {
      feature_name: '',
      image: null,
      status: 1,
    },
    validationSchema: Yup.object({
      feature_name: Yup.string()
        .required('Feature name is required')
        .min(3, 'Feature name must be at least 3 characters'),
      image: Yup.mixed()
        .nullable()
        .test('fileType', 'Only PDF or PNG files are allowed', (value) => {
          if (!value) return true;
          const extension = value.name.split('.').pop().toLowerCase();
          return extension === 'pdf' || extension === 'png';
        })
        .test('fileSize', 'File must be less than 2MB', (value) =>
          !value || value.size <= MAX_FILE_SIZE
        ),
      status: Yup.number()
        .required('Status is required')
        .oneOf([0, 1], 'Invalid status value'),
    }),
    onSubmit: async (values) => {
      try {
        setLoader(true);

        const formData = new FormData();
        formData.append('feature_name', values.feature_name);
        formData.append('status', values.status);
        if (values.image) {
          formData.append('image', values.image);
        }

        const response = await fetchData(
          'features', 
          'POST',
          formData,
          {},
          {},
          navigate,
          '/features',
          dispatch
        );

        toast.success(response.message || 'Feature added successfully');
        navigate('/features');
      } catch (error) {
        toast.error(error.message || 'Failed to add feature');
        console.error(error);
      } finally {
        setLoader(false);
      }
    },
  });

  const handleFileChange = (event) => {
    const file = event.currentTarget.files[0];
    formik.setFieldValue('image', file);

    if (file?.type === 'image/png') {
      const reader = new FileReader();
      reader.onloadend = () => setImagePreview(reader.result);
      reader.readAsDataURL(file);
    } else {
      setImagePreview(null);
    }
  };

  return (
    <div  className="w-full my-4 mx-auto">
   

      
                  <div className="flex  lg:flex-row flex-col lg:justify-between justify-start lg:items-center items-start gap-3 w-full">
                                  <h1 className="text-black text-[1.475rem] text-Black font-[Bold] ">
                                            Create Feature
                                           </h1>
                                 <BackButton text="Back" to="/features" />
                                       </div>
      <div  className="bg-white rounded-lg shadow w-full lg:mb-[30px] mt-4  mb-[7rem]">
        <div className="p-4 flex md:flex-row rounded-t-lg gradiant2 flex-col gap-3 justify-between md:items-center border-lightGray border-b ">
          <h1 className="lg:text-[0.875rem] text-[13px]  tracking-[0.0625rem] text-[#856800] font-[bold] uppercase">
            Create Feature
          </h1>
        </div>
        <form onSubmit={formik.handleSubmit} className="p-4">
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2 p-4 my-4">
            {/* Feature Name */}
            <div>
              <ThinTextField
                label="Feature Name"
                name="feature_name"
                value={formik.values.feature_name}
                onChange={formik.handleChange}
              />
              {formik.touched.feature_name && formik.errors.feature_name && (
                <p className="text-sm text-red-500 mt-1">
                  {formik.errors.feature_name}
                </p>
              )}
            </div>

            {/* File Upload */}
            <div className="flex flex-col">
              <label className="text-sm font-medium text-gray mb-1">
                Upload File (PNG or PDF, max 2MB)
              </label>
              <input
                type="file"
                accept=".png,.pdf"
                name="image"
                onChange={handleFileChange}
                className='`text-[15px] font-[InterLight] text-[#565656] bg-[#ebeef2] focus:bg-[#dde2e9] py-2 px-4 outline-none border-[#dde2e9] border rounded-[0.35rem]'
              />
              {formik.touched.image && formik.errors.image && (
                <p className="text-sm text-red-500 mt-1">{formik.errors.image}</p>
              )}
              {formik.values.image && (
                <div className="mt-2">
                  {formik.values.image.type === 'image/png' ? (
                    <img
                      src={imagePreview}
                      alt="Preview"
                      className="h-32 border rounded object-contain"
                    />
                  ) : (
                    <p className="text-gray-600 text-sm">
                      📄 {formik.values.image.name}
                    </p>
                  )}
                </div>
              )}
            </div>

            {/* Status Dropdown */}
            <div>
              <ThinDropdown
                label="Status"
                name="status"
                options={[
                  { value: 1, label: 'Active' },
                  { value: 0, label: 'Inactive' },
                ]}
                value={formik.values.status}
                onChange={(e) =>
                  formik.setFieldValue('status', parseInt(e.target.value))
                }
              />
              {formik.touched.status && formik.errors.status && (
                <p className="text-sm text-red-500 mt-1">{formik.errors.status}</p>
              )}
            </div>
          </div>
          <div className='p-4'>
          <AddButton text="Submit" type="Submit" />
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddFeature;
